import { MessengerWithTabs } from 'components/Messanger';
import MessangerLoader from 'components/Sceletons/MessangerLoader';
import dayjs from 'dayjs';
import React, { CSSProperties } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hook';
import fetchChatData from 'store/reducers/chatCreator';
import { setChatMessage, setChatStatus, setMessageForReply, setSelectedChatRoom, updateChatLastMessage } from 'store/slices/chatsSlice';
import { setIsRSidebarCollapsed, setSelectedKeys } from 'store/slices/windowStateSlice';
import classes from './Chat.module.scss';
import utc from 'dayjs/plugin/utc';
import WebViewer from 'components/Webviewer/WebViewer';
import { setIsOpenViewer } from 'store/slices/viewerSlice';
import { useLocation, useNavigate, useParams } from 'react-router';
import systemPages, { getKeyFromLocation, technicalPages } from 'helpers/pagesAndLocation';
import ai from 'api/ai_assistant';

dayjs.extend(utc);

type ChatProps = {
  embedded?: boolean;
  aiAssistant?: boolean;
}

const Chat = ({embedded, aiAssistant}: ChatProps) => {
  const { isLoadedSession, roomChatLoading, selectedChat, messageForReply, globalChatLoading } = useAppSelector(
    (state) => state.chat
  );
  const { dataRoom } = useAppSelector((state) => state.dataRoom);
  const { userData } = useAppSelector((state) => state.userData);
  const { isUploadingSomeChat } = useAppSelector((state) => state.windowState);
  const { documentUrl, isDocumentError, isDocumentLoading, isOpenViewer } = useAppSelector((state) => state.viewer);
  const { currentEditorToken } = useAppSelector((state) => state.aiFunctions);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  React.useEffect(() => {    
    !Boolean(embedded) && dispatch(setSelectedKeys(['chat']));
    dispatch(setIsRSidebarCollapsed({ collapsed: true, width: 0, entity: 'chat_setting' }));
    // !selectedChat && dispatch(setViewType('Table')); // Кривое переключение на главный чат комнаты после чата по документу

    return () => {
      if (!location.pathname.includes('chat') && !location.pathname.includes('global-chats'))
        dispatch(setSelectedChatRoom(null));
    };
  }, []);

  const onSendMessage = (message: string, attachment_ids: any) => {    
    if ((!message || !message.trim()) && !attachment_ids) return;
    const id = dayjs().utc().format('YYYY-MM-DDTHH:mm:ss.SSSSSS');
    dispatch(
      setChatMessage({
        message: message || '',
        attachment_ids,
        id,
        status: 'pending',
        replied_to: messageForReply ? messageForReply : null,
      })
    );
    dispatch(
      fetchChatData({
        data: {
          status: 'pending',
          message: message || '',
          created_at: id,
          timestamp: id,
          email: userData?.email!,
          user_name: `${userData?.first_name} ${userData?.last_name}`,
          room_id: dataRoom?.id!,
          chat_id: selectedChat?.id!,
          replied_to: messageForReply ? messageForReply : null,
          attachment_ids: attachment_ids,
        },
        type: 'add',
      })
    );
    dispatch(updateChatLastMessage({ chat_id: selectedChat?.id!,  
      content: message,
      created_at: id,
      attachment_ids: attachment_ids,
      status: 'pending',
      id: id,
      author: {
        id: userData?.id!,
        name: `${userData?.first_name} ${userData?.last_name}`,
        email: userData?.email!,
      },
     }));
    dispatch(setChatStatus('send'));    
    aiAssistant && ai.sendMessageChatAIAssistant({access_token: currentEditorToken!, text: message});
    dispatch(setMessageForReply(null));
  };

  const onWebViewClose = () => {
    navigate(window.location.pathname);
    dispatch(setIsOpenViewer(false));
  };

  const isLoadingChat = !isLoadedSession && ((dataRoom?.id && roomChatLoading) || globalChatLoading);
  const selectedKeys = getKeyFromLocation(location.pathname, params.room);
  const isNeedToDisplayRoomNavigation =
    !selectedKeys.includes('mobile') && ![...systemPages, ...technicalPages].includes(selectedKeys);
  
  const mainStyle: CSSProperties = {
    height: isNeedToDisplayRoomNavigation ? 'calc(100dvh - 105px)' : '100dvh',
    maxHeight: '100dvh',
  };

  return (
    <>
      <div className={classes.wrapper}>
        <div className={classes.mainSpace} style={mainStyle}>
          {(isLoadingChat || isUploadingSomeChat)
            ? <MessangerLoader />
            : <MessengerWithTabs
              onSendMessage={onSendMessage}
              embedded={embedded}
              aiAssistant={aiAssistant}
            />
          }
        </div>
      </div>

      {/* НЕ используется в активных копонентах, устаревщий способ отображения документов, в модалке без перехода к самому документу */}
      {isOpenViewer && (
        <React.Suspense fallback={<div />}>
          <WebViewer
            errorMessage={isDocumentError}
            onClose={onWebViewClose}
            isLoading={isDocumentLoading}
            url={documentUrl}
          />
        </React.Suspense>
      )}
    </>
  );
};

export default Chat;
